import { default as cpdCategorysConfiguration } from './cpdCategorys';
import { default as getConfiguration } from './get';
import { default as industriesWithCpdCategorysConfiguration } from './industriesWithCpdCategorys';
import { default as rolesConfiguration } from './roles';

export const configurations = [
  getConfiguration,
  rolesConfiguration,
  cpdCategorysConfiguration,
  industriesWithCpdCategorysConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/industry/configurations/index.js